export const MAX_FILE_SIZE_BYTES = 200 * 1024 * 1024;
export const MAX_FILE_SIZE_KILO_BYTES = MAX_FILE_SIZE_BYTES / 1024;
export const MAX_FILE_SIZE_MEGABYTES = MAX_FILE_SIZE_KILO_BYTES / 1024;

